<div class="tags-wrap">
  <ng-container *ngFor="let tag of tags">
    <div class="tag">
      {{ tag.name }}
    </div>
  </ng-container>
</div>